import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Prociono\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\"],\"style\":[\"normal\"],\"display\":\"swap\",\"variable\":\"--font-prociono\"}],\"variableName\":\"prociono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/client-providers.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/index.css");
